import React from 'react';
import Datatable from '../../../../../../components/molecules/datatable';
import { TableColumns } from './configuration';

interface IProps {
  mode: 'VIEW' | 'EDIT';
  data: any;
}
export default function DatatableList(props: IProps) {
  const MODE = props.mode;
  return (
    <Datatable
      loading={true}
      data={props.data || []}
      columns={TableColumns(MODE)}
    />
  );
}
